import { render, staticRenderFns } from "./WordCloudBox.vue?vue&type=template&id=99f2aa82&scoped=true&"
import script from "./WordCloudBox.vue?vue&type=script&lang=ts&"
export * from "./WordCloudBox.vue?vue&type=script&lang=ts&"
import style0 from "./WordCloudBox.vue?vue&type=style&index=0&id=99f2aa82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f2aa82",
  null
  
)

export default component.exports